export default {
  FETCH_DOSSIER_RELATED_DOSSIERS: 'FETCH_DOSSIER_RELATED_DOSSIERS'
}
